<template>
  <a-card :bordered='false' :bodyStyle='{paddingTop:"0px"}'>
    <a-tabs>
      <a-tab-pane :key="1" tab="窜货经销商统计">
        <dealer></dealer>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="窜货商品统计">
        <goods></goods>
      </a-tab-pane>
      <a-tab-pane :key="3" tab="窜货出库单统计">
        <order></order>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
  import dealer from './components/dealer.vue'
  import goods from './components/goods.vue'
  import order from './components/order.vue'
  export default {
    components: { dealer,goods,order },
    setup() {
      
    }
  };
</script>